import { createApi } from "@reduxjs/toolkit/dist/query/react";
import ApiService from "./ApiService";
import { baseQuery } from "./basequery";

export async function apiGetNotificationCount() {
  return ApiService.fetchData({
    url: "/notification/count/",
    method: "get",
  });
}

export async function apiGetNotificationList() {
  return ApiService.fetchData({
    url: "/notification/list/",
    method: "get",
  });
}

export async function apiGetSearchResult(data) {
  return ApiService.fetchData({
    url: "/search/query/",
    method: "post",
    data,
  });
}

export const getCookie = (name) => {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
};


export const CommonService = createApi({
  reducerPath: "commonService",
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => ({
        url: "/socials/notifications/",
      }),
    }),

    postNotification: builder.mutation({
      query: (data) => ({
        url: `/socials/notifications/`,
        body: { id: data?.endpoints }
      })
    })
  }),
});

export const { useGetNotificationsQuery, usePostNotificationMutation } = CommonService;